export default __webpack_public_path__ + "static/media/raghav.95fae22a.jpeg";